import React from "react";
import "./screen_loader.css";

const Screen_loader = () => {
  return (
    <div
      className="h-screen w-fu
    flex items-center justify-center"
    >
      <div className="loader_screen"></div>
    </div>
  );
};

export default Screen_loader;
